import { render, staticRenderFns } from "./Basic-2.vue?vue&type=template&id=3062a0fd&scoped=true&"
import script from "./Basic-2.vue?vue&type=script&lang=js&"
export * from "./Basic-2.vue?vue&type=script&lang=js&"
import style0 from "./Basic-2.vue?vue&type=style&index=0&id=3062a0fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3062a0fd",
  null
  
)

export default component.exports